import { useMemo } from 'react';
import { FORM_FIELD_TYPE } from 'js/components/common/Form/constants';

import { useValidateEmail } from '../useValidateEmail';
import { useUpdateFieldValue } from '../useUpdateFieldValue';
import { useValidateUserName } from '../useUserNameFieldValidation';

import * as Types from './types';

export const useInternalValidate = (options: Types.IUseInternalValidationOptions) => {
    const {
        field,
        validationConfig,
        requestReCaptchaToken,
        abortReCaptchaTokenRequest
    } = options;

    const { name, type, validation, validationRules } = field;
    const isFieldWithInternalValidation = validation && validationRules?.some(rule => rule.type === 'internal');

    const updateFieldValue = useUpdateFieldValue({ fieldName: name });

    const validateUserName = useValidateUserName({
        fieldName: name,
        updateFieldValue,
        validationConfig,
        requestReCaptchaToken,
        abortReCaptchaTokenRequest
    });

    const validateEmail = useValidateEmail({
        fieldName: name,
        validationConfig,
        requestReCaptchaToken,
        abortReCaptchaTokenRequest
    });

    return useMemo(() => {
        if (!isFieldWithInternalValidation) {
            return;
        }

        switch (type) {
            case FORM_FIELD_TYPE.EMAIL:
                return validateEmail;
            case FORM_FIELD_TYPE.USER_NAME:
                return validateUserName;
            default:
                break;
        }
    }, [
        type,
        validateEmail,
        validateUserName,
        isFieldWithInternalValidation
    ]);
};
